import { render, staticRenderFns } from "./EmployeeGroupPage.vue?vue&type=template&id=20c1f7b8&scoped=true&"
import script from "./EmployeeGroupPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1f7b8",
  null
  
)

export default component.exports